// removed by extract-text-webpack-plugin
module.exports = {"Afterhero":"src-components-Program-Afterhero----Afterhero-module---Afterhero---1S0UM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Program/Afterhero/Afterhero.module.scss
// module id = 730
// module chunks = 168707334958949